
/* styles */
require("!!style!css!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-54e51203&scoped=true!autoprefixer!px2rem?remUnit=37.5&remPrecision=8!less-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./logout.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015!../../node_modules/vue-loader/lib/selector?type=script&index=0!./logout.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-54e51203!../../node_modules/vue-loader/lib/selector?type=template&index=0!./logout.vue"),
  /* scopeId */
  "data-v-54e51203",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/logout.vue
// module id = 309
// module chunks = 1